import React, {PureComponent} from 'react';
import {CardBody, CardFooter, CardHeader, CardTitle} from 'reactstrap';
import LinkIcon from 'react-feather/dist/icons/link.js';
import PropTypes from 'prop-types';

import Availability from '../../Freelance/Component/Availability/Availability.jsx';
import CompanyType from '../../CompanyType/CompanyType.jsx';
import FrontCard from '../FrontCard.jsx';
import Labels from '../../Freelance/Component/Labels/Labels.jsx';
import Picture from '../../Picture/Picture.jsx';
import Price from '../../Freelance/Component/Price/Price.jsx';
import Skills from '../../Skills/Skills.jsx';

import conf from '../../../../shared/conf.js';

export default class FreelanceFrontCard extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    const {className, isAdmin, score, user, ...props} = this.props;

    const currentUser = props?.currentUser ?? null;
    const isOwner = currentUser && user.id === currentUser.id;

    const currentUserCanView = currentUser ?
      (isAdmin || currentUser.account_type !== conf.accountTypes.freelance || isOwner) :
      false
    ;

    const image = currentUserCanView ? user?.image?.square ?? null : null;
    const altImage = currentUser ? user?.fullname ?? '' : 'Vous devez être connecté pour voir la photo des consultants';

    const completeClassName = ((user.gray || !user.complete) ? 'no-' : '').concat('complete');

    return (
      <FrontCard className={`freelance-search-card-front ${completeClassName} h-100 text-center ${className}`}>
        {isAdmin ?
          <CardHeader>
            <Labels freelance={props} user={user}/>
          </CardHeader> : ''
        }
        <CardBody>
          <div className="arrow-right"><LinkIcon/></div>
          <div className="circle-avatar">
            <Picture
              src={image}
              alt={altImage}
              isReviewed={props?.is_reviewed && isAdmin}
              isGold={user?.gold}
              className="picture"/>
          </div>
          <CardTitle>{user?.fullname ?? ''}</CardTitle>
          {isAdmin ?
            <p>
              Freelance #{props?.id ?? 'N/A'} ; User #{user?.id ?? 'N/A'}
            </p> : ''
          }
          <p>{props.title}</p>
          <p>{user?.city?.label ?? ''} {user.relocation ? '+ France' : ''}</p>
          <small><CompanyType user={user}/></small>
          <Skills
            key={props.id}
            length="3"
            forceNoLink={true}
            className="skills flex-wrap mx-3 mt-3"
            list={(props?.master_skills?.length ? props.master_skills : []).concat(props?.expertises?.length ? props.expertises : [])}
          />
        </CardBody>
        <CardFooter>
          <Availability freelance={props}/>
          <Price freelance={props}/>
        </CardFooter>
        {score ? (<div className="score">Score: {Math.round(score)}</div>) : ''}
      </FrontCard>
    );
  }
}
